const currencies = {
  RUB: 'Руб',
  USD: 'Дол',
};

export const getCurrencyText = (currencyCode: string) =>
  currencyCode in currencies ? currencies[currencyCode as keyof typeof currencies] : currencyCode;

/*
export const getCurrencyText = (currencyCode: string) => {
  try {
    return new Intl.NumberFormat('ru', {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'name',
      maximumFractionDigits: 0,
    })
        .format(1)
        .slice(2);
  } catch (e) {
    console.error('getCurrencyText', e);
    return currencyCode;
  }
};*/
